/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { LogoutIcon, SettingsIcon, ZoomIcon } from '../Icons';
import { useTranslation } from 'react-i18next';
import { Auth } from 'aws-amplify';
import { useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { onAuthState } from 'app/actions/authActions';
import Logo from 'assets/images/logo.png';
import Input from '../Input';
import Dropdown from '../Dropdown';
import Button from '../Button';
import MobileDropMenu from './MobileDropMenu';
import MobileNavMenu from './MobileNavMenu';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';
import AvatarImg from '../AvatarImg';
import CreditBalance from '../Credits/CreditBalance';
import { getLocalizedPath } from 'utils/languageHelpers';

const Header = () => {
  const account = useSelector(state => state.account);
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const history = useHistory();
  const { pathname } = location;
  const url = new URL(window.location.href);
  const isSearchPage = /\/search/.test(pathname);
  const [search, setSearch] = useState(url.searchParams.get('q') || '');

  const onFormChange = ({ target }) => {
    setSearch(target.value);
    if (!target.value) {
      history.push(getLocalizedPath('/dashboard'));
    }
  };

  const onStartSearch = e => {
    e.preventDefault();
    if (search) {
      history.push(getLocalizedPath(`/search?q=${search}`));
    } else {
      history.push(getLocalizedPath('/dashboard'));
    }
  };

  const goToSearch = () => {
    history.push(getLocalizedPath('/search'));
  };

  useEffect(() => {
    if (!isSearchPage) {
      setSearch('');
    }
  }, [location]);

  return (
    <header className='py-7 py-md-15'>
      <div className='container'>
        <div className='d-flex align-items-center justify-content-between'>
          <Link to={getLocalizedPath('/dashboard')}>
            <img src={Logo} alt='Logo' className='w-118-px w-162-px-md' />
          </Link>
          <div className='d-flex align-items-center'>
            <form
              className='search-block d-none d-md-flex align-items-center border rounded-6'
              onSubmit={onStartSearch}
            >
              <Input
                type='text'
                name='topSearch'
                onChange={onFormChange}
                value={search}
                placeholder={t('ph_search')}
                className='mb-0 w-100'
                inputClassName='border-0'
              />
              <Button type='submit' className='btn-sm btn-primary px-5 py-5 m-2'>
                <ZoomIcon />
              </Button>
            </form>
            <ul className='d-flex list-unstyled align-items-center mb-0'>
              <li className='mr-10'>
                <CreditBalance onClick={() => history.push(getLocalizedPath('/profile/credits'))} />
              </li>
              {/* Polls button hidden as requested */}
              {/* <li className='ml-15 d-none d-md-block'>
                <Link to='/polls' className='text-dark fw-500'>
                  <PollIcon className='mr-5' />
                  {t('nav_poll')}
                </Link>
              </li> */}
              <li className='pb-1 mr-10 d-md-none'>
                <button className='btn p-0 svg-black' onClick={goToSearch}>
                  <ZoomIcon />
                </button>
              </li>
              <li className='ml-0 ml-md-15 text-dark d-none d-md-block'>
                <Dropdown
                  onClickTitle={() => history.push(getLocalizedPath('/profile'))}
                  title={
                    <div className='d-flex align-items-center'>
                      <div className='profile-avatar mr-0 mr-md-5 rounded-10'>
                        <AvatarImg width='30px' height='30px' size='sm' picture={account.picture} name={account.name} />
                      </div>
                      <div>{t('nav_my_profile')}</div>
                    </div>
                  }
                >
                  <Dropdown.Item path={getLocalizedPath('/profile')}>
                    <SettingsIcon className='mr-3' />
                    {t('text_settings')}
                  </Dropdown.Item>
                  <Dropdown.Item
                    onClick={() => {
                      dispatch(onAuthState(0));
                      Auth.signOut();
                    }}
                  >
                    <LogoutIcon className='mr-3' />
                    {t('text_logout')}
                  </Dropdown.Item>
                </Dropdown>
              </li>
              <li className='ml-0 text-dark d-md-none'>
                <MobileDropMenu />
              </li>
              <li className='pb-1 ml-10 d-md-none'>
                <MobileNavMenu />
              </li>
            </ul>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
